module.exports = __webpack_public_path__ + "static/media/25.c43deb61.gif";